var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 868.29 33.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.89,4.48L0,.09l.06-.09h5.28l2.81,4.48H3.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.9,4.48L21.01.09l.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.08,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.09,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.05,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.15,33.77v-.77c.88-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.31,31.79v-3.03h15.45v3.03h-15.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.17,33.77v-.77c.88-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.08,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.14,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.14,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.98,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.99,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m276.17,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m294.18,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.14,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m337.24,33.77v-.77c.88-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.4,31.79v-3.03h15.45v3.03h-15.45Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m379.26,33.77v-.77c.89-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m400.18,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.24,18.1v-3.95h15.82v3.95h-15.82Zm0,6.8v-3.95h15.82v3.95h-15.82Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m444.23,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m466.07,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m487.08,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m507.26,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m525.27,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m547.23,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m568.33,33.77v-.77c.89-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m584.49,31.79v-3.03h15.45v3.03h-15.45Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m610.35,33.77v-.77c.89-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m631.27,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m651.32,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m675.32,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m697.16,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m718.17,4.48l-3.89-4.39.06-.09h5.28l2.81,4.48h-4.26Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m738.35,15.17l-1.45-4.42v-4.54h4.79v4.54l-1.45,4.42h-1.88Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m756.36,21.35v-4.88h7.85v4.88h-7.85Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m778.33,27.4v-5.56h5.93v5.56h-5.93Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m799.43,33.77v-.77c.88-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m815.58,31.79v-3.03h15.45v3.03h-15.45Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m841.44,33.77v-.77c.88-.89,1.54-1.79,1.98-2.7.43-.92.65-1.88.65-2.89h-2.78v-6.3h6.09v5.28c0,1.44-.24,2.79-.71,4.03-.47,1.25-1.16,2.36-2.07,3.35h-3.15Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m862.36,27.4v-5.56h5.93v5.56h-5.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSeperator);
export default __webpack_public_path__ + "static/media/mobile-seperator.32575facef021f8a97c985b36f8b698a.svg";
export { ForwardRef as ReactComponent };